import { Environment } from './environment.model';

export const environment: Environment = {
  production: true,
  microFrontEnds: [
    {
      remoteEntry: 'https://payments-panel.sandbox.eshopworld.com/v2/dist/remoteEntry.js',
      remoteName: 'paymentPanel',
      exposedModule: './PaymentPanelModule',
      rel: 'paymentPanel',
      moduleId: 'default',
      type: 'script'
    }
  ],
  themeBaseUrl: 'https://checkout-composable-ui.sandbox.eshopworld.com',
  fraudBootstrapScriptUrl: 'https://payments-panel.sandbox.eshopworld.com/js/fraudbootstrap.min.js',
  paymentsPanelApiUrl: 'https://payments-panel.sandbox.eshopworld.com',
  feroot: {
    bundleId: '35464b53-8b70-4908-9d47-cba415ea1d82',
    enabled: true
  }
};
